// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jx6nh","toggle":"styles_toggle__37_v5","preview":"styles_preview__IF7F-"};